import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet'
import "../App.css"
import $ from "jquery";

import {
  deleteCard,
  saveCard,
  addCard,
  stripeTokenHandler
} from "../Actions/Dashboard/Card"

import {
  bind,
  joinDiscord,
  unbind,
  requestReward
} from "../Actions/Dashboard/Key"

import {
  cancel,
  cancelAuthroizeNet,
  submitCancel,
  upgrade,
  addon,
  openInvoice
} from "../Actions/Dashboard/Subscription"

import {
    getPosts
  } from "../Actions/Dashboard/Posts"

import bootbox from "bootbox";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Components/Posts/posts.css';
import '../Components/Posts/catalogue.css';
import "bootstrap"
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { Elements, CardElement } from '@stripe/react-stripe-js';
import StripeCardElementGrabber from "../Components/StripeCardElementGrabber"
import CircleLoader from "../Components/CircleLoader"
import Post from "../Components/Posts/Post";
import Catalogue from "../Components/Posts/Catalogue";
import {loadStripe} from '@stripe/stripe-js';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import currencies from "../Locales/currencies";

const Dashboard = () => {

  const [data, setData] = useState({
    sidebar: [],
    useAuthorizeNet: false,
    scripts: [], color: "", secondary_color: "", statusColor: "", logo: "", name: "",
    avatar: "", username: "", key: "", email: "", invoices: [], referralAmount: 0, referral: "", rewards: [], pk_key: "", card: {}, cards: [], addOns: [], subscriptions: []
  })
  const [page, setPage] = useState("account");
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [key, setKey] = useState("")
  const [invoice, setInvoice] = useState("")
  const [defaultCardId, setDefaultCardId] = useState("")
  const [defaultCard, setDefaultCard] = useState("")
  const [selectedCard, setSelectedCard] = useState("")
  const [cancelAtPeriod, setCancelAtPeriod] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [postsLoaded, setPostsLoaded] = useState(false)
  const [stripeLoaded, setStripeLoaded] = useState(false)
  const [stripePromise, setStripePromise] = useState(false)
  const [invoiceModal, setInvoiceModal] = useState(false)
  const [cardModal, setCardModal] = useState(false)
  const [addNewCard, setAddNewCard] = useState(false)
  const [reward, setReward] = useState("")
  const [addOnPlan, setAddOnPlan] = useState("")
  const [upgrades, setUpgrades] = useState({})
  // POSTS STATES
  const [posts, setPosts] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [search, setSearch] = useState("");
  const [catalogue, setCatalogue] = useState([]);

  const [useCatalogue, setUseCatalogue] = useState('');
  const [activeCatalogue, setActiveCatalogue] = useState([]);

  const [metaPixel, setMetaPixel] = useState("");
  const [googleAnalytics, setGoogleAnalytics] = useState("");
  const [tiktokPixel, setTiktokPixel] = useState("");

  const [idempotent, setIdempotent] = useState("")
  const grabberRef = useRef();
  const { t, i18n } = useTranslation();

  // Randomly generate UUIDV4 for request
  const uuidv4 = () =>  {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  useEffect(() => {
    // pull info
    pullData();
  }, [])

  useEffect(() => {
    if (data.key !== "") {
      setKey(data.key)
      if (data.rewards && data.rewards.length > 0) {
        setReward(data.rewards[0].id);
      }
      if (data.invoices && data.invoices.length > 0) {
        setInvoice(data.invoices[0].hosted_invoice_url)
      }
      if (data.card && data.card.last4) {
        setDefaultCard(`${data.card.brand.toUpperCase()} ****${data.card.last4}`);
        setDefaultCardId(data.card.id);
        setSelectedCard(data.card.id);
      } 
      else if (data.card && data.card.cardNumber) {
        setDefaultCard(data.card.cardNumber);
        setDefaultCardId(data.card.id);
        setSelectedCard(data.card.id);
      }
      else {
        setDefaultCard("No default card");
      }
      if (data.addOns && data.addOns.length > 0) {
        setAddOnPlan(data.addOns[0].planId);
      }
      var plans = [];
      var upgrades = {}
      if (!data.useAuthorizeNet) {
        data.subscriptions.map(subscription => {
          plans.push(subscription.plans[0].id);
          subscription.upgrades.map(upgrade => {
            if (subscription.plans[0].id in upgrades) {
              upgrade.selected = false;
              upgrades[subscription.plans[0].id].push(upgrade);
            } 
            else {
              upgrade.selected = true;
              upgrades[subscription.plans[0].id] = [upgrade];
            }
          });
          
        })
      }

      setUpgrades(upgrades);
      pullPosts();
    }
    if (!stripeLoaded) {
      if (data.pk_key !== "") {
        var stripePromiseVar = loadStripe(data.pk_key);
        setStripePromise(stripePromiseVar);
        setDataLoaded(true)
        setStripeLoaded(true)
        setPostsLoaded(true);
        setIdempotent(uuidv4());
      }
    } else {
      setDataLoaded(true)
    }
  }, [data])


  useEffect(() => {
    if (postsLoaded == true) {
        CreateSidebar();
    }
  }, [postsLoaded])

  const pullPosts = () => {
    setPostsLoaded(false);
    getPosts(setPosts, setCatalogue, setPostsLoaded);
  }

  const pullData = () => {
    setDataLoaded(false)
    fetch("/dashboardInfo", {redirect: 'manual'})
    .then((res) => {
      if (res.redirected) {
        window.location.href = res.url;
      }
      return res;
    })
    .then((res) => res.json())
    .then((res) => {
      if (res.success) {
        if (res && res.metaPixel) {
          setMetaPixel(res.metaPixel);
        }
        if (res && res.googlePixel) {
          setGoogleAnalytics(res.googlePixel);
        }
        if (res && res.tiktokPixel) {
          setTiktokPixel(res.tiktokPixel);
        }
        return setData(res)
      } else {
        // some error
        window.location.href = res.redirect;
        return;
      }
    }).catch((err) => {
      return bootbox.alert(err.toString());
    })
  }


  const CreateSidebar = () => {
    if ($(".sideshow").length) {

      $(".sideshow").on("click", function() {

        // IF ITS HIDING SIDEBAR
        if ($(this).children("i").eq(0).css("display") == "none") {

          $(this).children("i").toggle();
          $("#wrapper").removeClass("toggled");
          $(this).css("left", "0px");


        } else {
          $(this).children("i").toggle();
          $("#wrapper").addClass("toggled");
          $(this).css("left", "235px");

        }
      
      });
      
      // window.setInterval(function() {
      //   if (!$("#wrapper").hasClass("toggled")) {
      //     $(".sideshow").css("left", "-5px");
      //   }
      // }, 1);
    
      return;
    } else {
      setTimeout(CreateSidebar, 50);
    }
  }

  const dynamicSort = (property) => {
    var sortOrder = 1;

    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a,b) {
        if(sortOrder == -1){
            return b[property].localeCompare(a[property]);
        }else{
            return a[property].localeCompare(b[property]);
        }        
    }
  }



  const sortPosts = (mode) => {
    if (mode === "alphabet") {
      var newPosts = posts.sort(dynamicSort("title"));
      setPosts([]);
      setTimeout(() => {
        setPosts(newPosts);
      }, 50)
    }

    else if (mode === "oldest") {
      var newPosts = posts.sort(dynamicSort("visibleOn"));
      setPosts([]);
      setTimeout(() => {
        setPosts(newPosts);
      }, 50)
    }

    else if (mode === "newest") {
      var newPosts = posts.sort(dynamicSort("-visibleOn"));
      setPosts([]);
      setTimeout(() => {
        setPosts(newPosts);
      }, 50)
    }

  }

  console.log(data);

  return (
    <div>
      {dataLoaded === true && stripeLoaded === true && postsLoaded === true ?
        <div id="wrapper">
           
            <Helmet>
                <title>Dashboard - {data.name}</title>
                <style>{`
                    :root {
                    --main-color: ${data.color};
                    --secondary-color: ${data.secondary_color};
                    `}
                </style>

                {data.scripts.map(script => (
                <script src={script} ></script>
                ))}
            </Helmet>



            {
              googleAnalytics && (
                <Helmet>
                  <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalytics}`}></script>
                  <script>
                    {`
                      window.dataLayer = window.dataLayer || [];
                      function gtag(){dataLayer.push(arguments);}
                      gtag("js", new Date());
  
                      gtag("config", '${googleAnalytics}');
                    `}
                    </script>
                </Helmet>
              )
            }

            {
              metaPixel && (
                <Helmet>
                  <script>
                    {`
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '${metaPixel}');
                    fbq('track', 'PageView');
                    `}
                  </script>
                </Helmet>
              )
            }

            {
              tiktokPixel && (
                <Helmet>
                  <script>
                    {`
                    !function (w, d, t) {
                      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
                      ttq.load('${tiktokPixel}');
                      ttq.page();
                    }(window, document, 'ttq');
                    `}
                  </script>
                </Helmet>
              )
            }




            <div id="sidebar-wrapper">
                <div style={{paddingLeft: '30px', paddingRight: '30px', marginTop: '45px', marginBottom: '20px'}}>
                    <div style={{"overflow":"hidden","whiteSpace":"nowrap","textOverflow":"ellipsis"}}>
                        <img id="sidebar-logo" style={{"width":"45px","borderRadius":"100px","marginRight":"8px"}} src={data.logo} />
                        <span style={{"fontSize":"15px","color":"#11142D","fontWeight":"700"}} id="group_name">{data.name}</span>
                    </div>
                </div>
                <div className={"list-group list-group-flush"}>


                    {data.key !== "" ? (
                                        <a onClick={() => {setPage("posts")}} className={`list-group-item ${page === "posts" ? 'active-item' : ''}`}>
                                        <svg style={{"verticalAlign":"-3px","marginRight":"15px"}} width="24" height="22" viewBox="0 0 24 22" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                            d="M10.8008 0.290506L2.88757 8.16787L0.798118 10.2679L0.296418 10.7875L0.204562 10.8975L0.112196 11.0423C0.0881003 11.0879 0.073661 11.1397 0.0159036 11.3473L0.001672 11.4765C-0.00844547 11.6232 0.0241834 11.6987 0.187328 12.0765L0.298278 12.1743C0.635427 12.4701 0.666201 12.4726 1.00473 12.5L3.50472 12.499V20.9982C3.50472 21.5505 3.95244 21.9982 4.50472 21.9982H9.00473C9.55701 21.9982 10.0047 21.5505 10.0047 20.9982V15.5H13.0047V20.9982C13.0047 21.5505 13.4524 21.9982 14.0047 21.9982H18.5047L18.6213 21.9915C19.1187 21.9337 19.5047 21.511 19.5047 20.9982V12.499L22.0047 12.5L22.1715 12.4851C22.3824 12.4596 22.4486 12.4028 22.8129 12.0905L22.917 11.8574C23.0255 11.6066 23.0205 11.5641 22.9959 11.3518L22.9338 11.1311C22.9148 11.0694 22.9032 11.0447 22.8828 11.011L22.7779 10.8546L22.7587 10.8308C22.7204 10.7834 22.6724 10.7289 22.6091 10.6599L22.1196 10.1466C21.8464 9.86562 21.4826 9.49652 21.0278 9.03898L15.9042 3.93995C14.805 2.85209 13.5729 1.63482 12.2078 0.288105C11.8174 -0.0969687 11.1898 -0.0958977 10.8008 0.290506ZM3.38473 10.499L11.5077 2.407L17.6368 8.47646L19.6587 10.499L18.5047 10.5L18.3881 10.5067C17.8908 10.5645 17.5047 10.9872 17.5047 11.5V19.998H15.0037L15.0047 15.5C15.0047 14.3954 14.1093 13.5 13.0047 13.5H10.0047L9.85546 13.5055C8.8206 13.5818 8.00472 14.4456 8.00472 15.5L8.00373 19.998H5.50472V11.5L5.498 11.3834C5.44023 10.886 5.01756 10.5 4.50472 10.5L3.38473 10.499Z"
                                            fill="#808191" />
                                        </svg>
                                        <span>{t("Feed")}</span>
                                        </a>
                    ) : null}


                    <a onClick={() => {setPage("account")}} id="settings-nav" className={`list-group-item ${page === "account" ? 'active-item' : ''}`}>
                        <svg style={{"verticalAlign":"-5px","marginRight":"17px","marginLeft":"0px"}} width="23" height="23"
                            viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                            d="M12.7709 0C13.5855 0 14.3127 0.493079 14.6194 1.23635L14.6751 1.38826L15.2305 3.11729L16.218 2.37893C16.9674 1.81857 17.9971 1.85637 18.7017 2.44886L18.8299 2.56644L20.4336 4.1701C21.0952 4.83176 21.2049 5.85631 20.7191 6.63837L20.6211 6.78202L19.8827 7.76945L21.6117 8.32493C22.3873 8.57408 22.9288 9.26596 22.9935 10.0674L23 10.2291V12.7709C23 13.5855 22.5069 14.3127 21.7637 14.6194L21.6117 14.6751L19.8827 15.2305L20.6211 16.218C21.1814 16.9674 21.1436 17.9971 20.5511 18.7017L20.4336 18.8299L18.8299 20.4336C18.1682 21.0952 17.1437 21.2049 16.3616 20.7191L16.218 20.6211L15.2305 19.8827L14.6751 21.6117C14.4259 22.3873 13.734 22.9288 12.9326 22.9935L12.7709 23H10.2291C9.41449 23 8.68727 22.5069 8.38056 21.7637L8.32493 21.6117L7.76945 19.8827L6.78202 20.6211C6.03263 21.1814 5.00292 21.1436 4.29827 20.5511L4.1701 20.4336L2.56644 18.8299C1.90478 18.1682 1.7951 17.1437 2.28086 16.3616L2.37893 16.218L3.11729 15.2305L1.38826 14.6751C0.612718 14.4259 0.0711668 13.734 0.00650242 12.9326L0 12.7709V10.2291C0 9.41449 0.493079 8.68727 1.23635 8.38056L1.38826 8.32493L3.11729 7.76945L2.37893 6.78202C1.81857 6.03263 1.85637 5.00292 2.44886 4.29827L2.56644 4.1701L4.1701 2.56644C4.83176 1.90478 5.85631 1.7951 6.63837 2.28086L6.78202 2.37893L7.76945 3.11729L8.32493 1.38826C8.57408 0.612718 9.26596 0.0711668 10.0674 0.00650242L10.2291 0H12.7709ZM12.7709 2H10.2291L9.6736 3.72903C9.6059 3.93974 9.50371 4.13775 9.37117 4.31499C8.74277 5.15537 7.58021 5.36064 6.70708 4.81193L6.57175 4.71901L5.58432 3.98065L3.98065 5.58432L4.71901 6.57175C4.85155 6.74899 4.95375 6.947 5.02144 7.15771C5.3432 8.15927 4.83369 9.22864 3.876 9.62006L3.72903 9.6736L2 10.2291V12.7709L3.72903 13.3264C3.93974 13.3941 4.13775 13.4963 4.31499 13.6288C5.15537 14.2572 5.36064 15.4198 4.81193 16.2929L4.71901 16.4283L3.98065 17.4157L5.58432 19.0193L6.57175 18.281C6.74899 18.1485 6.947 18.0463 7.15771 17.9786C8.15927 17.6568 9.22864 18.1663 9.62006 19.124L9.6736 19.271L10.2291 21H12.7709L13.3264 19.271C13.3941 19.0603 13.4963 18.8622 13.6288 18.685C14.2572 17.8446 15.4198 17.6394 16.2929 18.1881L16.4283 18.281L17.4157 19.0193L19.0193 17.4157L18.281 16.4283C18.1485 16.251 18.0463 16.053 17.9786 15.8423C17.6568 14.8407 18.1663 13.7714 19.124 13.3799L19.271 13.3264L21 12.7709V10.2291L19.271 9.6736C19.0603 9.6059 18.8622 9.50371 18.685 9.37117C17.8446 8.74277 17.6394 7.58021 18.1881 6.70708L18.281 6.57175L19.0193 5.58432L17.4157 3.98065L16.4283 4.71901C16.251 4.85155 16.053 4.95375 15.8423 5.02144C14.8407 5.3432 13.7714 4.83369 13.3799 3.876L13.3264 3.72903L12.7709 2ZM14.3284 8.67157C15.8905 10.2337 15.8905 12.7663 14.3284 14.3284C12.7663 15.8905 10.2337 15.8905 8.67157 14.3284C7.10948 12.7663 7.10948 10.2337 8.67157 8.67157C10.2337 7.10948 12.7663 7.10948 14.3284 8.67157ZM10.0858 10.0858C9.30474 10.8668 9.30474 12.1332 10.0858 12.9142C10.8668 13.6953 12.1332 13.6953 12.9142 12.9142C13.6953 12.1332 13.6953 10.8668 12.9142 10.0858C12.1332 9.30474 10.8668 9.30474 10.0858 10.0858Z"
                            fill="#808191" />
                        </svg>
                        <span>{t("Account")}</span>
                    </a>
                    {data.sidebar.map(sidebar => {
                      return (
                        <a href={sidebar.url} target="_blank" className={"list-group-item"}>
                        <svg style={{"verticalAlign":"-5px","marginRight":"17px","marginLeft":"0px"}} width="24" height="22"
                            viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                            d="M18.6 0C20.4152 0 21.8981 1.42244 21.995 3.21345L22 3.4V8C22 8.55229 21.5523 9 21 9C20.4872 9 20.0645 8.61396 20.0067 8.11662L20 8V3.4C20 2.67228 19.4448 2.07425 18.7348 2.00641L18.6 2H3.4C2.67228 2 2.07425 2.55523 2.00641 3.26517L2 3.4V18.6C2 19.3277 2.55523 19.9258 3.26517 19.9936L3.4 20H8C8.55229 20 9 20.4477 9 21C9 21.5128 8.61396 21.9355 8.11662 21.9933L8 22H3.4C1.58482 22 0.101877 20.5776 0.0050309 18.7865L0 18.6V3.4C0 1.58482 1.42244 0.101877 3.21345 0.0050309L3.4 0H18.6Z"
                            fill="#808191" />
                            <path fillRule="evenodd" clipRule="evenodd"
                            d="M10.5304 19.6521L10.5734 19.7677C10.8511 20.396 11.69 20.57 12.1936 20.0664L13.9639 18.295L16.7521 21.0825C17.1427 21.473 17.7758 21.473 18.1664 21.0825L20.9948 18.2541L21.078 18.1599C21.383 17.7676 21.3553 17.2003 20.9948 16.8399L18.2069 14.052L19.9144 12.3456C20.4476 11.8123 20.2212 10.9032 19.5002 10.6823L8.37023 7.27319C7.60376 7.03841 6.88643 7.75574 7.12121 8.52221L10.5304 19.6521ZM9.58393 9.73604L17.3239 12.107L16.0861 13.3454L16.0029 13.4396C15.6979 13.8319 15.7256 14.3992 16.0861 14.7596L18.8729 17.547L17.4589 18.961L14.6719 16.1739L14.5777 16.0907C14.1854 15.7856 13.6182 15.8134 13.2577 16.1739L11.9549 17.476L9.58393 9.73604Z"
                            fill="#808191" />
                        </svg>
                        <span>{sidebar.name}</span>
                        </a>
                      )
                    })}
                   


                    <a id="" href="/logout" className={"list-group-item"}>
                    <svg style={{"verticalAlign":"-5px","marginRight":"17px","marginLeft":"0px"}} width="24" height="22"
                        viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                        d="M18.6 0C20.4152 0 21.8981 1.42244 21.995 3.21345L22 3.4V8C22 8.55229 21.5523 9 21 9C20.4872 9 20.0645 8.61396 20.0067 8.11662L20 8V3.4C20 2.67228 19.4448 2.07425 18.7348 2.00641L18.6 2H3.4C2.67228 2 2.07425 2.55523 2.00641 3.26517L2 3.4V18.6C2 19.3277 2.55523 19.9258 3.26517 19.9936L3.4 20H8C8.55229 20 9 20.4477 9 21C9 21.5128 8.61396 21.9355 8.11662 21.9933L8 22H3.4C1.58482 22 0.101877 20.5776 0.0050309 18.7865L0 18.6V3.4C0 1.58482 1.42244 0.101877 3.21345 0.0050309L3.4 0H18.6Z"
                        fill="#808191" />
                        <path fillRule="evenodd" clipRule="evenodd"
                        d="M10.5304 19.6521L10.5734 19.7677C10.8511 20.396 11.69 20.57 12.1936 20.0664L13.9639 18.295L16.7521 21.0825C17.1427 21.473 17.7758 21.473 18.1664 21.0825L20.9948 18.2541L21.078 18.1599C21.383 17.7676 21.3553 17.2003 20.9948 16.8399L18.2069 14.052L19.9144 12.3456C20.4476 11.8123 20.2212 10.9032 19.5002 10.6823L8.37023 7.27319C7.60376 7.03841 6.88643 7.75574 7.12121 8.52221L10.5304 19.6521ZM9.58393 9.73604L17.3239 12.107L16.0861 13.3454L16.0029 13.4396C15.6979 13.8319 15.7256 14.3992 16.0861 14.7596L18.8729 17.547L17.4589 18.961L14.6719 16.1739L14.5777 16.0907C14.1854 15.7856 13.6182 15.8134 13.2577 16.1739L11.9549 17.476L9.58393 9.73604Z"
                        fill="#808191" />
                    </svg>
                    <span>{t("Sign Out")}</span>
                    </a>
                </div>
            </div>
            <div className={"sideshow"}>
              <i className={"fa fa-angle-right"} aria-hidden="true"></i>
              <i className={"fa fa-angle-left"} aria-hidden="true" style={{display:'none'}}></i>
            </div>

            {
                data.key === "" ? (
                    <div id="page-container">
                    <h1 className="mt-4">Manage Account</h1>
                    <div id="discord-welcome">
                        <img src={data.avatar} id="user-img" alt="" />
                        <h1>{t("Welcome")} {data.username}
                        </h1>
                    </div>
                    <div id="key-box">
                        <h1>{t("Bind Key")}</h1>
                        <form id="bind-form" onSubmit={(e) => {e.preventDefault(); bind(key, setButtonDisabled, pullData, t)}}>
                        <input onChange={e => setKey(e.target.value)} id="newKey" type="text" value={key}/>
                        <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} id="bind-button" type="submit" value={t("Bind")} />
                        </form>
                    </div>
                    </div>
                      
                ) : (
                    <>
                      {!data.useAuthorizeNet ? (
                          <div id="page-container">
                          <div style={{display: page == "account" ? "block" : "none"}}>
                          <h1 className="mt-4">Manage Account</h1>
                          <div id="discord-welcome">
                                  <img src={data.avatar} id="user-img" alt="" />
                                  <h1>{t("Welcome")} {data.username}
                                  </h1>
                                  <div>
                                      <form onSubmit={(e) => { e.preventDefault(); joinDiscord(setButtonDisabled, t); }}>
                                      <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Open Discord")} />
                                      </form>
                                  </div>
                                 
                          </div>
                              <div id="billing-box">
                              <h1>{t("Billing")}</h1>
                              <p><strong>{t("Email")}: </strong>
                              {data.email}
                              </p>
                              <p><strong>{t("Invoices")}:</strong> <a onClick={() => setInvoiceModal(!invoiceModal)} style={{ cursor: "pointer", color: "var(--main-color)" }}>{t("View Invoices")}</a></p>
                              <p id="card"><strong>{t("Active Card")}: </strong><span>{defaultCard}</span></p>
                              <form onSubmit={(e) => { e.preventDefault(); setCardModal(!cardModal) }}>
                              <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Update Payment Info")} />
                              </form>
                              </div>
                              {
                              data.subscriptions.map(subscription => {
                              return (
                                  <div className="sub-box">
                                  <h1>{t("Subscription")}</h1>
                                  <p><strong>{t("Status")}: </strong><span className={subscription.statusColor}>{t(subscription.status)}</span> </p>
                                  {subscription.trial !== null ? 
                                      <p><strong>{t("Trial Ends")}: </strong> {(new Date(subscription.trial * 1000)).toDateString()}</p> 
                                  : 
                                      null
                                  }
                                  <p><strong>{t("Renewal Date")}: </strong>{new Date(subscription.expiry * 1000).toLocaleDateString()}</p>
                                  {
                                      subscription.plans.map(plan => {
                                      return (
                                          <>
                                          <p><strong>{t("Plan")}: </strong> {plan.name} {plan.currency ? currencies[plan.currency.toUpperCase()].symbol.default.display : "$"}{plan.price}</p>
                                          </>
                                      )
                                      })
                                  }
                                  <form onSubmit={(e) => { e.preventDefault(); cancel(subscription.id, subscription.cancelAtPeriod, setButtonDisabled, pullData, t) }}>
                                      {subscription.status === "Active" ? 
                                      <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} id="cancel-button" className="cancel" type="submit" value={t("Cancel Subscription")} /> 
                                      : 
                                      <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} id="cancel-button" className="" type="submit" value={t("Reactivate Subscription")}></input>}
                                  </form>
                                  

                                  {
                                      subscription.upgrades.length > 0 ?
                                          <div className="upgrade-box">
                                          <h1>{t("Update Plan")}</h1>
                                          <p><strong>{t("Card Used")}: </strong><span>{defaultCard}</span></p>
                                              <form onSubmit={(e) => {
                                              e.preventDefault();
                                              var plan;
                                              let plans = upgrades[subscription.plans[0].id];
                                              for (var i = 0; i < plans.length; i++) {
                                                  if (plans[i].selected === true) {
                                                  plan = plans[i];
                                                  }
                                              }
                                              if (plan) {
                                                  upgrade(subscription.id, plan, idempotent, setButtonDisabled, pullData, t);
                                                  upgrade(subscription.id, plan, idempotent, setButtonDisabled, pullData, t);
                                              }
                                              }}>
                                              <select onChange={(e) => {
                                                  var selectedUpgrade = e.target.value;
                                                  var upgradesVar = upgrades;
                                                  var planUpgrades = upgradesVar[subscription.plans[0].id];
                                                  for (var i = 0; i < planUpgrades.length; i++) {
                                                  if (planUpgrades[i].selected == true) {
                                                      planUpgrades[i].selected = false;
                                                  }
                                                  }
                                                  for (var i = 0; i < planUpgrades.length; i++) {
                                                  if (planUpgrades[i].planId == selectedUpgrade) {
                                                      planUpgrades[i].selected = true;
                                                  }
                                                  }
                                                  setUpgrades(upgradesVar);
                                              }}>
                                                  <option disabled>{t("Select a Plan")}</option>
                                                  {
                                                  subscription.upgrades.map(upgrade => {
                                                      return (
                                                      <option key={upgrade.planId} value={upgrade.planId}>
                                                          {`${upgrade.name} ${upgrade.currency ? currencies[upgrade.currency.toUpperCase()].symbol.default.display : "$"}${upgrade.price}`}
                                                      </option>
                                                      )
                                                  })
                                                  }
                                              </select>
                                              <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Update")} />
                                              <p style={{ width: "75%", margin: "auto", marginTop: "10px", fontSize: "12px" }}>{t("When updating plan, your membership will be prorated.  If you are in the middle of a billing cycle, then you will only owe the difference between your new membership rate minus your current membership rate (e.g. $1200 - $120 = $1,080 total).")}</p>
                                              </form>
                                          </div>
                                      : null
                                      }
                  
                                  </div>
                              )
                              })
                      }
                      
                      
                      {data.addOns.length > 0 ? (
                          <div id="addon-box">
                          <h1>{t("Add-On Products")}</h1>
                          <p id="addon-card"><strong>{t("Card Used")}: </strong><span>{defaultCard}</span></p>
                          <form id="addon-form" onSubmit={(e) => {
                              e.preventDefault();
                              let plan = data.addOns.filter(addOn => (addOn.planId == addOnPlan))[0];
                              addon(plan, setButtonDisabled, pullData, t);
                          }}>
                              <select id="addon-plan" value={addOnPlan} onChange={(e) => {setAddOnPlan(e.target.value)}}>
                              <option key={-1} disabled>{t("Select a Plan")}</option>
                              {
                                  data.addOns.map(addOn => {
                                  return (
                                      <option key={addOn.planId} value={addOn.planId}>
                                      {`${addOn.name} ${addOn.currency ? currencies[addOn.currency.toUpperCase()].symbol.default.display : "$"}${addOn.price}`}
                                      </option>
                                  )
                                  })
                              }
                              </select>
                              <input id="addon" disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Purchase Add-On")} />
                          </form>
                          </div>
                      ) : null}



                      <div id="ref-box">
                          <h1>{t("Referral")}</h1>
                          <p><strong>{t("People Referred")}: </strong> {data.referralAmount}
                          </p>
                          <input readOnly value={data.referral} />
                          <form id="ref-form" onSubmit={(e) => { e.preventDefault(); requestReward(reward, pullData, t) }}>
                          <select id="reward" onChange={(e) => {setReward(e.target.value)}}>
                              {data.rewards.length > 0 ? (
                              data.rewards.map(reward => {
                                  return (
                                  <option key={reward.id} value={reward.id}>
                                      {`${reward.reward} (${reward.referral} referrals)`}
                                  </option>
                                  )
                              })
                              ) : (<option value="">{t("No Rewards Available")}</option>)
                              }
                          </select>
                          <input id="referral-request" disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Request Reward")} />
                          </form>
                      </div>

                      <div id="key-box">
                          <h1>{t("Key")}</h1>
                          <form onSubmit={(e) => { e.preventDefault(); unbind(pullData, setKey, setButtonDisabled, t) }}>
                          <input readOnly value={data.key} />
                          <input id="unbind-button" className="cancel" disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Unbind Discord")} />
                          </form>
                      </div>

                      <div id="invoices-modal" className={`data-modal ${invoiceModal ? "" : "modal-hidden"}`}>
                          <div className="modal-content">
                          <div className="modal-header">
                              <span onClick={(() => {setInvoiceModal(!invoiceModal)})} className="close">&times;</span>
                              <h2>{t("Invoices")}</h2>
                          </div>
                          <div className="modal-body">
                              <select id="invoice" value={invoice} onChange={(e) => {setInvoice(e.target.value)}}>
                              {
                                  data.invoices.map(invoice => {
                                  return (
                                      <option key={invoice.hosted_invoice_url} value={invoice.hosted_invoice_url}>
                                      {invoice.currency ? currencies[invoice.currency.toUpperCase()].symbol.default.display : "$"}{invoice.total / 100} {t("Paid on")} {(new Date(invoice.created * 1000)).toLocaleDateString("en-US")}
                                      </option>
                                  )
                                  })
                              }
                              </select>
                          </div>
                          <div className="modal-footer">
                              <a onClick={() => {window.open(invoice, '_blank')}} className="green">{t("View Invoice")}</a>
                          </div>
                          </div>
                      </div>

                      <div id="payment-modal" className={`data-modal ${cardModal ? "" : "modal-hidden"}`}>
                          <div className="modal-content">
                          <div className="modal-header">
                              <span onClick={() => {setCardModal(!cardModal)}} className="close">&times;</span>
                              <h2>{t("Manage Payment")}</h2>
                          </div>
                          <div className="modal-body">
                              {addNewCard ? (
                              <div className="edit-new">
                                  <Elements stripe={stripePromise}>
                                  <CardElement
                                      id="cardElement"
                                      options={{
                                      style: {
                                          base: {
                                          color: '#32325d',
                                          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                          fontSmoothing: 'antialiased',
                                          fontSize: '16px',
                                          '::placeholder': {
                                              color: '#aab7c4'
                                          }
                                          },
                                          invalid: {
                                          color: '#fa755a',
                                          iconColor: '#fa755a'
                                          }
                                      },
                                      }}
                                  />

                                  <StripeCardElementGrabber ref={grabberRef} />

                                  </Elements>
                                  <div className={`card-actions`}>
                                  <a onClick={() => setAddNewCard(!addNewCard)} className="red">{t("Cancel")}</a>
                                  </div>
                              </div>

                              ) : (
                              <div className="edit-default">
                                  <select id="cards" onChange={(e) => {setSelectedCard(e.target.value)}} value={selectedCard}>
                                  {
                                  data.cards.map(card => {
                                      return (
                                      <option key={card.id} value={card.id}>
                                          {`${card.brand.toUpperCase()} ****${card.last4}`}
                                      </option>
                                      )
                                  })
                                  }
                                  </select>
                                  <div className={"card-actions"}>
                                  <a onClick={() => setAddNewCard(!addNewCard)} className="green">{t("Add new")}</a>
                                  <a onClick={() => deleteCard(selectedCard, setCardModal, pullData, t)} className="red">{t("Remove")}</a>
                                  </div>
                              </div>
                              )}

                          </div>

                          {
                          addNewCard ? (
                              <div className="modal-footer">
                              <a onClick={() => addCard(grabberRef, setCardModal, setAddNewCard, pullData, t)} className="green">{t("Save new Card")}</a>
                              </div>
                          ) : (
                              <div className="modal-footer">
                              <a onClick={() => saveCard(selectedCard, setCardModal, pullData, t)} className="green">{t("Save as Default Card")}</a>
                              </div>
                          )
                          }
                          </div>

                      </div>
                          </div>
                        
                          <div style={{display: page == "posts" ? "block" : "none"}}>
                               <h1 className="mt-4">{t("Feed")}</h1>
                              <div className="feed-wrapper">
                                  <div className="feed-control">
                                    <Dropdown>
                                      <Dropdown.Toggle className="filter-button">
                                        <i className="fas fa-sort"></i>
                                        </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => {sortPosts("newest")}} href="">Newest</Dropdown.Item>
                                        <Dropdown.Item onClick={() => {sortPosts("oldest")}} href="">Oldest</Dropdown.Item>
                                        <Dropdown.Item onClick={() => {sortPosts("alphabet")}} href="">Alphabetical</Dropdown.Item>
                                      </Dropdown.Menu>
        
                                    </Dropdown>
                                      <svg className="icon" width="18" height="18" viewBox="0 0 21 22" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path fillRule="evenodd" clipRule="evenodd"
                                          d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2Z"
                                          fill="#b1b2bc" />
                                      <path fillRule="evenodd" clipRule="evenodd"
                                          d="M14.3596 14.2325C14.7838 13.8788 15.4143 13.9359 15.768 14.3601L20.7688 20.357C21.1225 20.7812 21.0654 21.4118 20.6412 21.7655C20.2171 22.1192 19.5865 22.0621 19.2328 21.6379L14.232 15.6409C13.8783 15.2168 13.9354 14.5862 14.3596 14.2325Z"
                                          fill="#b1b2bc" />
                                      </svg>
                                      <input value={search} onChange={(event) => {setSearch(event.target.value)}} className="search-feed" placeholder={t("Search")}>

                                      </input>
                                  </div>

                                  <div className="feed">
                                      {catalogue.length > 0 ? (
                                        <>
                                          <h2>{t("Catalogue")}</h2>
                                          <div style={{overflowX:'scroll', display:'inline-flex', marginTop:15, marginBottom:30}}>
                                            {
                                            catalogue.map(group => {
                                              return (
                                                <Catalogue useCatalogue={useCatalogue} setActiveCatalogue={setActiveCatalogue} setUseCatalogue={setUseCatalogue} data={group}></Catalogue>
                                              )
                                            })}
                                          </div>
                                        </>
                                      ) : null }

                                      {imageOpen === true && selectedImage !== "" ? (
                                      <div id="image-view">
                              
                                           <Lightbox
                                                mainSrc={selectedImage}
                                                onCloseRequest={() => {setImageOpen(false)}}
                                            />
                                          {/* <img src={selectedImage}></img> */}
                                      </div>
                                      ) : null}
                                      <h2>{t("Latest Posts")}</h2>
                                      {posts.map(post => {
                                      return (
                                          <>
                                          {useCatalogue !== '' ? (
                                            <>

                                              {activeCatalogue.includes(post.postId) ? (
                                                <>
                                                {search === "" ? (
                                                  <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                ) : (
                                                  <>
                                                      {post.title.toLowerCase().includes(search.toLowerCase()) ? (
                                                          <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                      ) : null}
                                                  </>
                                                )}
                                                </>
                                              ) : null}


                                            </>
                                          ) : (
                                              <>
                                              {search === "" ? (
                                                <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                              ) : (
                                                <>
                                                    {post.title.toLowerCase().includes(search.toLowerCase()) ? (
                                                        <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                    ) : null}
                                                </>
                                              )}
                                              </>
                                          )}

              
                                          </>
                                      )
                                      })}
                                  </div>
                              </div>
                          </div>
                 
                        </div>                        
                      ) : (
                        <div id="page-container">
                            <div style={{display: page == "account" ? "block" : "none"}}>
                              <h1 className="mt-4">Manage Account</h1>
                              <div id="discord-welcome">
                                      <img src={data.avatar} id="user-img" alt="" />
                                      <h1>{t("Welcome")} {data.username}
                                      </h1>
                                      <div>
                                          <form onSubmit={(e) => { e.preventDefault(); joinDiscord(setButtonDisabled, t); }}>
                                          <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Open Discord")} />
                                          </form>
                                      </div>
                                    
                              </div>


                              <div id="billing-box">
                                <h1>{t("Billing")}</h1>
                                <p><strong>{t("Email")}: </strong>
                                {data.email}
                                </p>
                                <p id="card"><strong>{t("Active Card")}: </strong><span>{defaultCard}</span></p>
                                <form onSubmit={(e) => { e.preventDefault(); setCardModal(!cardModal) }}>
                                <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Update Payment Info")} />
                                </form>
                              </div>


                              {

                                data.subscriptions.map(subscription => {
                                  return (
                                    <div className="sub-box">
                                      <h1>{t("Subscription")}</h1>
                                      <p><strong>{t("Status")}: </strong><span className={subscription.status == "active" ? "green" : "red"}>{subscription.status}</span> </p>
                                     
                                      <p><strong>{t("Renewal Date")}: </strong>{new Date(subscription.paymentSchedule.startDate).toLocaleDateString()}</p>
                                      <p><strong>{t("Plan")}: </strong> ${subscription.amount} / {subscription.paymentSchedule.interval.length} {subscription.paymentSchedule.interval.unit} </p>
                                      <form onSubmit={(e) => { e.preventDefault();
                                      
                                        cancelAuthroizeNet(subscription.id, setButtonDisabled, pullData, t)
                                      
                                      }}>
                                          {subscription.status === "active" ? 
                                          <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} id="cancel-button" className="cancel" type="submit" value={t("Cancel Subscription")} /> 
                                          : 
                                          <input disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} id="cancel-button" className="cancel" type="submit" value={t("Subscription Cancelled")}></input>}
                                      </form>
                                    </div>
                                  )
                                })
                              
                              }


                              <div id="ref-box">
                                <h1>{t("Referral")}</h1>
                                <p><strong>{t("People Referred")}: </strong> {data.referralAmount}
                                </p>
                                <input readOnly value={data.referral} />
                                <form id="ref-form" onSubmit={(e) => { e.preventDefault(); requestReward(reward, pullData, t) }}>
                                <select id="reward" onChange={(e) => {setReward(e.target.value)}}>
                                    {data.rewards.length > 0 ? (
                                    data.rewards.map(reward => {
                                        return (
                                        <option key={reward.id} value={reward.id}>
                                            {`${reward.reward} (${reward.referral} referrals)`}
                                        </option>
                                        )
                                    })
                                    ) : (<option value="">{t("No Rewards Available")}</option>)
                                    }
                                </select>
                                <input id="referral-request" disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Request Reward")} />
                                </form>
                            </div>

                            <div id="key-box">
                                <h1>{t("Key")}</h1>
                                <form onSubmit={(e) => { e.preventDefault(); unbind(pullData, setKey, setButtonDisabled, t) }}>
                                <input readOnly value={data.key} />
                                <input id="unbind-button" className="cancel" disabled={buttonDisabled} style={{opacity: buttonDisabled ? 0.7 : 1, cursor: buttonDisabled ? "no-drop" : "pointer"}} type="submit" value={t("Unbind Discord")} />
                                </form>
                            </div>

                            
                                <div id="payment-modal" className={`data-modal ${cardModal ? "" : "modal-hidden"}`}>
                                    <div className="modal-content">
                                    <div className="modal-header">
                                        <span onClick={() => {setCardModal(!cardModal)}} className="close">&times;</span>
                                        <h2>{t("Manage Payment")}</h2>
                                    </div>
                                    <div className="modal-body">
                                        {addNewCard ? (
                                        <div className="edit-new">
                                            <Elements stripe={stripePromise}>
                                            <CardElement
                                                id="cardElement"
                                                options={{
                                                style: {
                                                    base: {
                                                    color: '#32325d',
                                                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                                    fontSmoothing: 'antialiased',
                                                    fontSize: '16px',
                                                    '::placeholder': {
                                                        color: '#aab7c4'
                                                    }
                                                    },
                                                    invalid: {
                                                    color: '#fa755a',
                                                    iconColor: '#fa755a'
                                                    }
                                                },
                                                }}
                                            />

                                            <StripeCardElementGrabber ref={grabberRef} />

                                            </Elements>
                                            <div className={`card-actions`}>
                                            <a onClick={() => setAddNewCard(!addNewCard)} className="red">{t("Cancel")}</a>
                                            </div>
                                        </div>

                                        ) : (
                                        <div className="edit-default">
                                            <select id="cards" onChange={(e) => {setSelectedCard(e.target.value)}} value={selectedCard}>
                                            {
                                            data.cards.map(card => {
                                                return (
                                                <option key={card.id} value={card.id}>
                                                   {card.cardNumber}
                                                </option>
                                                )
                                            })
                                            }
                                            </select>
                                            <div className={"card-actions"}>
                                            {/* <a onClick={() => setAddNewCard(!addNewCard)} className="green">{t("Add new")}</a>
                                            <a onClick={() => deleteCard(selectedCard, setCardModal, pullData, t)} className="red">{t("Remove")}</a> */}
                                            </div>
                                        </div>
                                        )}

                                    </div>

                                    {
                                    addNewCard ? (
                                        <div className="modal-footer">
                                        <a onClick={() => addCard(grabberRef, setCardModal, setAddNewCard, pullData, t)} className="green">{t("Save new Card")}</a>
                                        </div>
                                    ) : (
                                        <div className="modal-footer">
                                        <a onClick={() => saveCard(selectedCard, setCardModal, pullData, t)} className="green">{t("Save as Default Card")}</a>
                                        </div>
                                    )
                                    }
                                    </div>

                              </div>


                            </div>



                          <div style={{display: page == "posts" ? "block" : "none"}}>
                               <h1 className="mt-4">{t("Feed")}</h1>
                              <div className="feed-wrapper">
                                  <div className="feed-control">
                                    <Dropdown>
                                      <Dropdown.Toggle className="filter-button">
                                        <i className="fas fa-sort"></i>
                                        </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => {sortPosts("newest")}} href="">Newest</Dropdown.Item>
                                        <Dropdown.Item onClick={() => {sortPosts("oldest")}} href="">Oldest</Dropdown.Item>
                                        <Dropdown.Item onClick={() => {sortPosts("alphabet")}} href="">Alphabetical</Dropdown.Item>
                                      </Dropdown.Menu>
        
                                    </Dropdown>
                                      <svg className="icon" width="18" height="18" viewBox="0 0 21 22" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path fillRule="evenodd" clipRule="evenodd"
                                          d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2Z"
                                          fill="#b1b2bc" />
                                      <path fillRule="evenodd" clipRule="evenodd"
                                          d="M14.3596 14.2325C14.7838 13.8788 15.4143 13.9359 15.768 14.3601L20.7688 20.357C21.1225 20.7812 21.0654 21.4118 20.6412 21.7655C20.2171 22.1192 19.5865 22.0621 19.2328 21.6379L14.232 15.6409C13.8783 15.2168 13.9354 14.5862 14.3596 14.2325Z"
                                          fill="#b1b2bc" />
                                      </svg>
                                      <input value={search} onChange={(event) => {setSearch(event.target.value)}} className="search-feed" placeholder={t("Search")}>

                                      </input>
                                  </div>

                                  <div className="feed">
                                      {catalogue.length > 0 ? (
                                        <>
                                          <h2>{t("Catalogue")}</h2>
                                          <div style={{overflowX:'scroll', display:'inline-flex', marginTop:15, marginBottom:30}}>
                                            {
                                            catalogue.map(group => {
                                              return (
                                                <Catalogue useCatalogue={useCatalogue} setActiveCatalogue={setActiveCatalogue} setUseCatalogue={setUseCatalogue} data={group}></Catalogue>
                                              )
                                            })}
                                          </div>
                                        </>
                                      ) : null }

                                      {imageOpen === true && selectedImage !== "" ? (
                                      <div id="image-view">
                              
                                           <Lightbox
                                                mainSrc={selectedImage}
                                                onCloseRequest={() => {setImageOpen(false)}}
                                            />
                                          {/* <img src={selectedImage}></img> */}
                                      </div>
                                      ) : null}
                                      <h2>{t("Latest Posts")}</h2>
                                      {posts.map(post => {
                                      return (
                                          <>
                                          {useCatalogue !== '' ? (
                                            <>

                                              {activeCatalogue.includes(post.postId) ? (
                                                <>
                                                {search === "" ? (
                                                  <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                ) : (
                                                  <>
                                                      {post.title.toLowerCase().includes(search.toLowerCase()) ? (
                                                          <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                      ) : null}
                                                  </>
                                                )}
                                                </>
                                              ) : null}


                                            </>
                                          ) : (
                                              <>
                                              {search === "" ? (
                                                <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                              ) : (
                                                <>
                                                    {post.title.toLowerCase().includes(search.toLowerCase()) ? (
                                                        <Post setSelectedImage={setSelectedImage} setImageOpen={setImageOpen} post={post} />
                                                    ) : null}
                                                </>
                                              )}
                                              </>
                                          )}

              
                                          </>
                                      )
                                      })}
                                  </div>
                              </div>
                          </div>

                        </div>
                      )}
                    </>                    
                )
            }
 
 
      </div>
      :
      <div>
        <div id="navbar">
        </div>

        <div>
          <CircleLoader />
        </div>

      </div>
      }
    </div>

  )
}

export default Dashboard;
